// src/components/Footer.jsx

import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/footer.css";

import logoFD from "../images/LOGO FD FINAL.png";
import logoRiders from "../images/ridersmiami-logo.png";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="container">
        <div className="footer-inner">
          <div className="footer-left">
            <img src={logoFD} alt="FD" className="logo-fd" />
          </div>

          <div className="footer-center">
            <img
              src={logoRiders}
              alt="Riders Miami"
              className="footer-logo"
            />
          </div>

          <div id="contacto" className="footer-right">
            <p className="footer-version-text">Versión 1.0</p>
            <p className="footer-version-text">by F.D.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
